type LandingSectionEyebrowProps = {
  label: string
  className?: string
}

export function LandingSectionEyebrow({ label, className = '' }: LandingSectionEyebrowProps) {
  return (
    <div className={`flex flex-col gap-4 md:gap-8 ${className}`}>
      <div className="h-3 w-12 bg-pelgo-blue-light rounded-full" />
      <p className="text-xs font-medium text-gray-900 tracking-[0.24px] uppercase">{label}</p>
    </div>
  )
}
